import { useRef } from "react";

import Typography from "@mui/material/Typography";
import trimCloudinaryVideo from "../../utils/images/cloudinaryUtil";

const MediaPlayer = ({
  url,
  muted = true,
  duration,
  startTime,
  loop = false,
  mainMedia = false
}: {
  url: string,
  muted: boolean,
  duration: number,
  startTime: number,
  loop: boolean,
  mainMedia?: boolean
}) => {
  const player = useRef<HTMLVideoElement | null>(null);
  const config = { startTime, duration, quality: "low" };

  if (url)
    return (
      <video
        style={{
          position: "relative", zIndex: 5, borderRadius: "10px"
        }}
        width="100%"
        height={!mainMedia ? "90%" : "auto"
        }
        muted={muted}
        ref={player}
        autoPlay
        loop={loop}
        className={"react-player"}
        preload="none"
        playsInline
      >
        <source src={trimCloudinaryVideo(url, config)} type="video/webm" />
      </video>
    );
  return <Typography>Video Coming Soon</Typography>;
};

export default MediaPlayer;